import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export class QuickAddService {

  public quickAddDataSubject$ = new Subject<string>;

  constructor() { }


  getQuickAddData(): Observable<any> {
    return this.quickAddDataSubject$.asObservable();
  }



  updateQuickAddData(scope:string) {

    this.quickAddDataSubject$.next(scope);

  }
}
